export const getAvailableEdokModules = (state) => state.edok.availableModules || [];
